var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusAgreementSectionTitleWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money-bill-trend-up-solid",
    d: "M42.289.845a3.1,3.1,0,0,1,.62.925,2.743,2.743,0,0,1,.216,1.1v.009h0V11.5a2.875,2.875,0,0,1-5.75,0V9.82l-9.47,9.461A2.881,2.881,0,0,1,24,19.433l-8.185-7.026L7.619,19.433a2.874,2.874,0,0,1-3.737-4.366L13.944,6.442a2.875,2.875,0,0,1,3.746,0l8.041,6.891L33.305,5.75h-1.68a2.875,2.875,0,0,1,0-5.75H40.25a2.9,2.9,0,0,1,2.03.836l.009.009ZM0,27.313A4.314,4.314,0,0,1,4.313,23H41.688A4.314,4.314,0,0,1,46,27.313V41.688A4.314,4.314,0,0,1,41.688,46H4.313A4.314,4.314,0,0,1,0,41.688ZM4.313,37.375v4.313H8.625A4.314,4.314,0,0,0,4.313,37.375ZM8.625,27.313H4.313v4.313A4.314,4.314,0,0,0,8.625,27.313ZM41.688,37.375a4.314,4.314,0,0,0-4.312,4.313h4.313ZM37.375,27.313a4.314,4.314,0,0,0,4.313,4.313V27.313ZM28.75,34.5A5.75,5.75,0,1,0,23,40.25,5.75,5.75,0,0,0,28.75,34.5Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusAgreementSectionTitleWhiteIcon);
export default __webpack_public_path__ + "static/media/bonus-agreement-section-title-white-icon.88c94e7044eb0879e52b8382d49447c2.svg";
export { ForwardRef as ReactComponent };